import { ContentKey } from "../TalentDetails";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectTalentById,
  updateTalentSkills,
} from "../../talents/talentsSlice";
import { Talent, talentIsDeactivated } from "../../talents/talentAPI";
import { useParams } from "react-router-dom";
import SkillRows from "./SkillRows";
import { Grid } from "@mui/material";
import AddButton from "../../../common/components/functional/addButton/AddButton";
import isEmpty from "../../../common/helpers/isEmpty";
import { Skill } from "../../orders/orderAPI";
import useMessage from "../../../hooks/useMessage";
import { canExpertEditTalentProfile } from "../../user/accessRightChecks";
import { useContext } from "react";
import { AccessRightContext } from "../../user/AccessRightProvider";

type Props = {
  handleOpenEditModal: (content: ContentKey) => void;
};

const TalentSkills = ({ handleOpenEditModal }: Props) => {
  const { t } = useTranslation(["talentProfile", "common"]);
  const { talentId } = useParams();
  const dispatch = useAppDispatch();
  const { sendMessage } = useMessage();

  const talent = useAppSelector(
    (state) => selectTalentById(state, talentId as string) as Talent,
  );
  const { canEditTalentProfile } = useContext(AccessRightContext);

  const removeSkillCallback = (skillId: string) => {
    const currentSkills = talent.skills?.values || [];
    const currentSkillsVersion = talent.skills?.version || 0;

    if (talentId && !isEmpty(currentSkills) && currentSkillsVersion) {
      const newSkills = currentSkills.filter(
        (skill: Skill) => skill.id !== skillId,
      );

      dispatch(
        updateTalentSkills({
          talentId: talentId,
          skills: newSkills,
          version: currentSkillsVersion,
        }),
      )
        .unwrap()
        .then(() => sendMessage(t("talentProfile:skillsUpdated"), "success"));
    }
  };

  return (
    <FormSection title={t("talentProfile:skills")} margin>
      {talent.skills && !isEmpty(talent.skills.values) && (
        <SkillRows
          skills={talent.skills.values}
          removeSkillCallback={removeSkillCallback}
          disableRemove={!canEditTalentProfile}
        ></SkillRows>
      )}
      <Grid container spacing={2} sx={{ marginTop: "5px" }}>
        <Grid item xs={3} />
        <Grid item xs={9}>
          <AddButton
            label={t("talentProfile:addSkill")}
            onClick={() => handleOpenEditModal("skills")}
            accessRightChecks={[canExpertEditTalentProfile]}
            disabled={talentIsDeactivated(talent)}
          />
        </Grid>
      </Grid>
    </FormSection>
  );
};

export default TalentSkills;
